import { Button, Form, Input, InputNumber, Modal, message } from 'antd'
import React, { useEffect, useState } from 'react'
import { KpiV2Request } from '../../requests/KpiV2Request'

const LABEL_COL = { flex: '0 0 100px' }
const WRAPPER_COL = { flex: 1 }

/**
 * Modal "Thêm trọng số" (Thêm Aspect) theo màn hình mockup.
 * Props:
 *  - visible: boolean
 *  - onClose: () => void
 *  - onSuccess: () => void  (gọi lại để refresh aspect list)
 *  - editData: object | null  (nếu có thì là chế độ cập nhật)
 */
const KpiV2AddWeightModal = ({
  visible,
  onClose,
  onSuccess,
  editData = null,
}) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)

  const isEdit = Boolean(editData)

  useEffect(() => {
    if (!visible) {
      form.resetFields()
      return
    }
    if (isEdit && editData) {
      form.setFieldsValue({
        context: editData.context,
        weight: editData.weight,
      })
    }
  }, [visible, editData, isEdit, form])

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields()
      setLoading(true)

      const payload = {
        context: values.context,
        weight: values.weight,
      }

      if (isEdit) {
        await KpiV2Request.updateAspect(editData.id, payload)
        message.success('Cập nhật trọng số thành công!')
      } else {
        await KpiV2Request.createAspect(payload)
        message.success('Thêm trọng số thành công!')
      }

      onSuccess && onSuccess()
      onClose()
    } catch (error) {
      if (error?.errorFields) return
      const msg =
        error?.response?.data?.message || 'Đã xảy ra lỗi, vui lòng thử lại.'
      message.error(msg)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      title={isEdit ? 'Cập nhật trọng số' : 'Thêm trọng số'}
      visible={visible}
      onCancel={onClose}
      width={480}
      destroyOnClose
      footer={
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <Button onClick={onClose}>Hủy bỏ</Button>
          <Button type={'primary'} loading={loading} onClick={handleSubmit}>
            {isEdit ? 'Lưu' : '+ Tạo'}
          </Button>
        </div>
      }>
      <Form
        form={form}
        layout={'horizontal'}
        labelCol={LABEL_COL}
        wrapperCol={WRAPPER_COL}
        labelAlign={'left'}
        colon={false}>
        {/* * Khía cạnh */}
        <Form.Item
          name={'context'}
          label={'Khía cạnh'}
          rules={[{ required: true, message: 'Vui lòng nhập khía cạnh' }]}
          style={{ marginBottom: 16 }}>
          <Input placeholder={'Nhập khía cạnh'} />
        </Form.Item>

        {/* * Trọng số */}
        <Form.Item
          name={'weight'}
          label={' Trọng số'}
          rules={[
            { required: true, message: 'Vui lòng nhập trọng số' },
            {
              type: 'number',
              min: 0,
              max: 100,
              message: 'Trọng số phải từ 0 đến 100',
            },
          ]}
          style={{ marginBottom: 0 }}>
          <InputNumber
            min={0}
            max={100}
            placeholder={'Nhập trọng số'}
            addonAfter={'%'}
            style={{ width: '100%' }}
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default KpiV2AddWeightModal
